
define('text!templates/parts/menu/menu-tabs.html',[],function () { return '{{^onlyOneTabs}}\n<li>{{^empty}}<span class="{{icon}}"></span>\n    <p>{{#t}}{{title}}{{/t}}</p>{{/empty}}</li>{{/onlyOneTabs}}\n';});

